import { render, staticRenderFns } from "./PagamentosPendentes.vue?vue&type=template&id=99523a66"
import script from "./PagamentosPendentes.vue?vue&type=script&lang=js"
export * from "./PagamentosPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports